// extracted by mini-css-extract-plugin
module.exports = {"icon__container":"AppIcon_icon__container__X989C","app-icon":"AppIcon_app-icon__1EPGT"};